



























































































































import Component, { mixins } from 'vue-class-component';
import PlayerControlsMixin from '@/app/player/mixins/PlayerControlsMixin.ts';

@Component({
  name: 'slide-player-controls',
  props: ['hidePrev', 'hideNext']
})
export default class SlidePlayerControls extends mixins(PlayerControlsMixin) {}
